module.exports = __webpack_public_path__ + "img/jiGuang2.4134b014.png";